import { ITrainingMaterialIn, ITrainingMaterialUpdateIn } from "../../models/input/trainingApi/ITrainingMaterialIn";
import * as ApiWithToken from "../callApiWithToken";

const controller = 'TrainingMaterial';

const TrainingLibraryService = {
    getMaterials: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `${controller}/GetTrainingMaterialType?languageID=${languageId}`);
    },
    getCategories: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `${controller}/GetCategories?languageID=${languageId}`);
    },
    getResources: async function (materialId: number, categoryId: number, languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `${controller}/GetTrainingMaterial?languageID=${languageId}&categoryID=${categoryId}&materialTypeID=${materialId}`);
    },
    getMaterialsData: async function (languageId: number, pageNumber: number, pageSize: number, nameMaterialFilter: string, typeFilter: number | null, categoryFilter:number|null) {
        let url = `${controller}/GetTrainingMaterialData?languageID=${languageId}&pageNumber=${pageNumber}&pageSize=${pageSize}&materialNameFilter=${nameMaterialFilter}`;
    
        if (typeFilter !== null) {
            url += `&materialTypeFilter=${typeFilter}`;
        }
        if (categoryFilter !== null) {
            url += `&materialCategoryFilter=${categoryFilter}`;
        }
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + url);
    },
    updateTrainingMaterialActive: async function (materialId: number,active: boolean) {
        return ApiWithToken.patchApi(process.env.REACT_APP_COURSES_API + `${controller}/UpdateTrainingMaterialActive?trainingMaterialID=${materialId}&active=${active}`, null);
    },
    deleteTrainingMaterial: async function (materialId: number) {
        return ApiWithToken.deleteApi(process.env.REACT_APP_COURSES_API + `${controller}/DeleteTrainingMaterial?trainingMaterialID=${materialId}`);
    },
    getCycles: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `${controller}/GetTrainingMaterialCycle`);
    },
    getFormats: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `${controller}/GetTrainingMaterialFormats?LanguageID=${languageId}`);
    },
    postFiles: async function (file: FormData) {
        return ApiWithToken.postImageApi(process.env.REACT_APP_AGENDAS_API + `Activations/UploadActivationImage?Folder=TrainingMaterial`, file);
    },
    postTrainingMaterial: async function (trainingMaterialIn: ITrainingMaterialIn) {
        return ApiWithToken.postApi(process.env.REACT_APP_COURSES_API + `${controller}/CreateTrainingMaterial`, trainingMaterialIn);
    },
    updateTrainingMaterial: async function (trainingMaterialUpdateIn: ITrainingMaterialUpdateIn) {
        return ApiWithToken.putApi(process.env.REACT_APP_COURSES_API + `${controller}/UpdateTrainingMaterial`, trainingMaterialUpdateIn);
    },
}
export default TrainingLibraryService;
